var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"has--base-shadow has--medium-radius has--large-radius bg--base-white position-relative overflow-hidden",class:{
  'no-top-left-radius': _vm.clearTopLeftRadius,
  'no-top-radius': _vm.clearTopRadius,
  'py-2': _vm.clearVPaddings,
  'py-5': !_vm.clearVPaddings,
 }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }